import { a as r } from "./api.DHdhNbok.js";
const n = {
  sessions: "api/accounts/sessions",
  startProxy: "api/proxy/start",
  endProxy: "api/proxy/end"
}, a = async (o) => {
  const s = await r.post(n.sessions, {
    userId: o
  }), e = await s.json();
  if (!s.ok)
    throw new Error(e);
  return e;
}, i = async (o) => {
  const s = await r.post(n.startProxy, o);
  if (!s.ok)
    throw new Error("Problem with generating token");
  return s.json();
}, p = async () => {
  const o = await r.post(n.endProxy);
  if (!o.ok)
    throw new Error("Problem with generating token");
  return o.json();
};
export {
  p as a,
  i as g,
  a as r
};
